const al = {
 "studio": "Resource Studio",
 "studioSub": "ابحث ← عاين ← عدّل ← كلّف. مجموعة تجريبية: {n} مورد.",
 "search": "ابحث في الموارد",
 "all": "الكل",
 "language": "اللغة",
 "level": "المستوى",
 "type": "النوع",
 "eligibility": "متاح في",
 "why": "لماذا يناسب",
 "reg": {"label": "السجل اللغوي", "unspecified": "غير محدد", "v": {"formal": "رسمي", "informal": "غير رسمي", "mixed": "مختلط", "neutral_na": "محايد / لا ينطبق"}, "edit": "تعديل", "choose": "اختر السجل", "notePh": "ملاحظة قصيرة (اختيارية)", "notePhMixed": "من يستخدم أي صيغة؟ (مطلوبة عند الاختلاط)", "noteNeeded": "السجل المختلط يحتاج إلى ملاحظة قصيرة.", "saved": "تم حفظ السجل. نص النشاط لم يتغير."},
 "teacherOnly": "للمعلم فقط",
 "answerKey": "مفتاح الإجابات",
 "rubric": "سلّم التقييم",
 "notes": "ملاحظات للمعلم",
 "preview": "معاينة الطالب",
 "adapt": "عدّل",
 "assign": "كلّف الصف",
 "assigned": "تم التكليف لصفك.",
 "adapted": "حُفظت نسختك المعدّلة. الأصل لم يتغيّر.",
 "titleLabel": "العنوان",
 "instructionsLabel": "تعليمات الطالب",
 "save": "احفظ النسخة",
 "cancel": "إلغاء",
 "noResults": "لا توجد موارد تطابق هذه المرشحات.",
 "previewNote": "محتوى تجريبي — ليس جزءًا من المكتبة المستقبلية",
 "lab": "Discovery Lab",
 "labSub": "اكتشف ← جرّب ← افهم ← استخدم. بعض الأنشطة الصغيرة للاستكشاف.",
 "secTry": "جرّب هذا",
 "secPattern": "استكشف نمطًا",
 "secSolve": "حُلّ لغزًا",
 "secRead": "اقرأ واكتشف",
 "check": "تحقّق",
 "score": "{c} من {t} صحيحة",
 "tryAgain": "حاول مجددًا",
 "done": "تم",
 "know": "أعرفها",
 "again": "مرة أخرى",
 "flip": "انقر للقلب",
 "keep": "احتفظ بها لتمريني الشخصي",
 "kept": "حُفظت في بنك مفرداتك.",
 "cantKeep": "لغة هذه المجموعة ليست من لغات تعلّمك، لذا لا يمكن حفظها.",
 "practiceDone": "حُفظ التمرين لصفك.",
 "results": "نتائج الصف",
 "completed": "مكتمل",
 "attempted": "بدأ",
 "notAttempted": "لم يبدأ",
 "classResources": "موارد الصف",
 "open": "افتح",
 "minutes": "{n} دقيقة",
 "failed": "حدث خطأ. حاول مرة أخرى.",
 "close": "إغلاق",
 "cardOf": "{i} / {n}",
 "pickClass": "اختر صفًا",
 "mine": "تعديلاتي",
 "explored": "تم الاستكشاف",
 "fam": {
  "grammar": "قواعد",
  "worksheet": "ورقة عمل",
  "memory": "بطاقات",
  "game": "لغز",
  "form": "استمارة",
  "document": "وثيقة واقعية",
  "speaking": "محادثة",
  "reading": "قراءة وثقافة",
  "assessment": "تقييم",
  "data": "تحدّي بيانات"
 },
 "elig": {
  "public": "عام",
  "pro": "Pro",
  "education": "التعليم"
 }
};
al.p = {
 "sev": {"low": "منخفضة", "medium": "متوسطة", "high": "عالية"},
 "area": {"language_accuracy": "دقة اللغة", "naturalness": "الطبيعية", "cefr_fit": "ملاءمة المستوى", "answer_key": "مفتاح الإجابات", "instructions": "التعليمات", "pedagogy": "الجانب التربوي", "culture_stereotypes": "الثقافة والصور النمطية", "duplication": "التكرار", "formatting_script": "التنسيق والكتابة", "provenance": "المصدر", "objective_alignment": "التوافق مع الهدف", "teacher_learner_match": "توافق المعلّم والمتعلّم"},
 "edited": "عُدّل",
 "precheck": "مراجعة أولية بالذكاء الاصطناعي",
 "precheckRun": "تشغيل المراجعة الأولية",
 "precheckRerun": "إعادة",
 "precheckNone": "لا توجد مراجعة أولية بعد.",
 "precheckStale": "نسخة أقدم",
 "corrections": "{n} تصحيحات مقترحة (غير مطبّقة)",
 "precheckAdvisory": "استشارية فقط: لا تعتمد ولا تغيّر المورد أبدًا.",
 "pv": {"pass": "الذكاء الاصطناعي: سليم", "revise": "الذكاء الاصطناعي: يحتاج تعديلًا", "attention": "الذكاء الاصطناعي: يحتاج انتباهًا بشريًا"},
 "badJson": "صيغة JSON غير صالحة.",
 "contentSaved": "حُفظ المحتوى؛ والسابق محفوظ في السجل.",
 "editContent": "تعديل المحتوى",
 "editTrail": "يُسجَّل كل تغيير مع المحتوى السابق.",
 "history": "النسخ",
 "startRevision": "بدء مراجعة جديدة",
 "revisionStarted": "أُنشئت المسودة v{v}. تبقى النسخة المعتمدة فعّالة.",
 "histAssign": "{n} إسنادات تحتفظ بنسختها المجمّدة.",
 "confirmElig": "راجعتُ الإتاحة: {e}",
 "confirmEligFirst": "أكّد الإتاحة أولًا.",
 "objective": "الهدف",
 "provenance": "المصدر",
 "wave": "تصفية الدفعة",
 "booklet": "كتيّب الحصة",
 "summary": "ملخص PDF",
 "showMore": "عرض {n} أخرى",
 "showLess": "عرض أقل",
 "checklistIncomplete": "حدّد كل بنود القائمة أولًا.",
 "across": "أفقي",
 "down": "عمودي",
 "clueListNote": "اكتب كل إجابة بجانب رقمها. الرقم بين القوسين هو عدد الحروف.",
 "again": "تدرّب مرة أخرى",
 "exportVersion": "النسخة",
 "print": "طباعة",
 "export": "تصدير",
 "theme": "الموضوع",
 "grammar": "التركيز النحوي",
 "vocab": "المفردات",
 "function": "الوظيفة التواصلية",
 "duration": "دقائق",
 "teacherInstr": "تعليمات للذكاء الاصطناعي (اختياري)",
 "canonical": "مسودة رسمية لـ GetFluentLoop (تذهب للمراجعة)",
 "draftSaved": "حُفظت المسودة. تبقى خاصة بك حتى تجعلها جاهزة.",
 "draftNote": "مسودة ذكاء اصطناعي: راجع اللغة والمستوى والإجابات قبل الحفظ.",
 "fromFile": "أُنشئ من",
 "saveDraft": "حفظ المسودة",
 "uploaded": "رُفع الملف إلى ملفاتك.",
 "aiNote": "تبدأ مسودات الذكاء الاصطناعي دائمًا خاصة. لا يُنشر أو يُسند شيء تلقائيًا.",
 "uploadNote": "ارفع ملف PDF أو Word أو نص أو CSV أو Excel. يبقى الأصل كما هو؛ والنشاط مسودة خاصة منفصلة.",
 "uploadedAs": "حُفظ كمورد.",
 "useAsResource": "استخدامه كمورد ✓",
 "orCreate": "أو أنشئ نشاطًا منه أدناه:",
 "generating": "جارٍ الإنشاء…",
 "generate": "إنشاء مسودة",
 "createFromFile": "إنشاء نشاط من هذا",
 "suggestedBy": "اقترحه معلّم",
 "checklist": "قائمة الجودة",
 "checklistNote": "مراجعة بشرية. حدّد كل بند؛ يجب حل الملاحظات قبل المراجعة.",
 "reviewNote": "ملاحظة المراجعة / الاعتماد (داخلية)",
 "reviewSub": "قائمة التحرير للمحتوى الرسمي لـ GetFluentLoop. الملاحظات داخلية.",
 "reviewEmpty": "لا يوجد شيء هنا.",
 "packName": "اسم الحزمة",
 "packCreated": "أُنشئت الحزمة.",
 "packsSub": "تجمع الحزم الموارد والمهام والملفات. الحزم الشخصية خاصة ما لم يشاركها مشرف المدرسة.",
 "createPack": "إنشاء حزمة",
 "packsEmpty": "لا توجد حزم بعد.",
 "school": "المدرسة",
 "private": "خاص",
 "packSaved": "حُفظت كحزمة.",
 "subSub": "يبني حصة بديلة من موارد معتمدة فقط، دون ذكاء اصطناعي.",
 "themeOptional": "الموضوع (اختياري)",
 "buildLesson": "بناء الحصة",
 "lessonTotal": "الحصة: {n} دقيقة (المطلوب {r})",
 "mission": "مهمة",
 "missing": "لا يوجد مورد معتمد بعد",
 "subNote": "اطبع كل جزء من Resource Studio. مفاتيح الإجابات للمعلّم فقط.",
 "savePack": "حفظ كحزمة",
 "linked": "أُضيف إلى المهمة.",
 "useInMission": "استخدام في مهمة",
 "startMission": "بدء مسودة مهمة",
 "orExisting": "أو أرفقه بإحدى مهامك المحفوظة:",
 "noMissions": "لا توجد مهام محفوظة بهذه اللغة.",
 "attach": "إرفاق",
 "addedToPack": "أُضيف إلى الحزمة.",
 "choosePack": "اختر حزمة",
 "addToPack": "إضافة إلى حزمة",
 "readyDone": "جاهز للإسناد.",
 "markReady": "اجعله جاهزًا",
 "unshared": "لم يعد مشتركًا.",
 "shared": "تمت المشاركة مع مدرستك.",
 "unshare": "إيقاف المشاركة",
 "share": "مشاركة مع المدرسة",
 "suggest": "اقتراحه لمكتبة GetFluentLoop",
 "draftPrivate": "مسودة خاصة: أنت فقط تراها. اجعلها جاهزة لإسنادها.",
 "suggestNote": "تُنشأ نسخة مراجعة منفصلة لمحرري GetFluentLoop. تبقى نسختك كما هي.",
 "rights": "حقوقك في المشاركة",
 "suggestNotePh": "ما يجب أن يعرفه المحررون (اختياري)",
 "suggested": "أُرسل إلى قائمة مراجعة GetFluentLoop.",
 "send": "إرسال",
 "denied": "Resource Studio مخصّص للمعلّمين الموثّقين.",
 "draftNoAssign": "اجعله جاهزًا قبل الإسناد.",
 "schoolShared": "مشترك في مدرستي",
 "missionResources": "موارد هذه المهمة",
 "attachResources": "إرفاق موارد (نفس اللغة)",
 "noCompatible": "لا توجد موارد جاهزة بهذه اللغة.",
 "previewCombined": "معاينة مع الموارد",
 "pickMissionFor": "اختر مهمة لربطها بـ {id} ({lang})، ثم أرفقه في خطوة الإسناد.",
 "ver": {
  "learner": "ورقة المتعلّم",
  "teacher": "نسخة المعلّم",
  "answer_key": "مفتاح الإجابات",
  "teacher_guide": "دليل المعلّم"
 },
 "grp": {
  "individual": "فردي",
  "pairs": "أزواج",
  "groups": "مجموعات",
  "whole_class": "الصف كله"
 },
 "mode": {
  "ai": "مسودة ذكاء اصطناعي",
  "upload": "من ملف"
 },
 "out": {
  "worksheet": "ورقة عمل",
  "grammar_discovery": "اكتشاف القواعد",
  "flashcards": "بطاقات",
  "crossword": "كلمات متقاطعة / لغز",
  "interactive_form": "نموذج تفاعلي",
  "reading": "قراءة",
  "speaking_cards": "بطاقات محادثة",
  "exit_ticket": "بطاقة خروج",
  "data_challenge": "تحدي البيانات"
 },
 "st": {
  "draft": "مسودة",
  "reviewed": "مُراجَع",
  "approved": "معتمد",
  "retired": "مسحوب",
  "superseded": "مستبدَل",
  "teacher_ready": "جاهز"
 },
 "cv": {
  "pass": "سليم",
  "concern": "ملاحظة",
  "na": "لا ينطبق"
 },
 "do": {
  "reviewed": "تحديد كمُراجَع",
  "approved": "اعتماد",
  "draft": "إعادة إلى المسودة",
  "retired": "سحب"
 },
 "pp": {
  "warmups": "تمهيدات 10 دقائق",
  "speaking": "أسبوع المحادثة",
  "revision": "مراجعة الامتحان",
  "reading": "أسبوع القراءة",
  "grammar": "اكتشاف القواعد",
  "substitute": "معلّم بديل",
  "other": "أخرى"
 },
 "slot": {
  "starter": "البداية",
  "main": "النشاط الرئيسي",
  "speaking": "المحادثة",
  "resource": "ورقة / مورد",
  "exit": "بطاقة خروج"
 },
 "rt": {
  "own_work": "عملي الخاص",
  "cc_by": "CC BY",
  "cc0": "CC0",
  "public_domain": "ملكية عامة",
  "licensed_for_reuse": "مرخّص لإعادة الاستخدام"
 },
 "tab": {
  "library": "المكتبة",
  "create": "إنشاء",
  "packs": "الحزم",
  "substitute": "حزمة البديل",
  "review": "المراجعة"
 },
 "ck": {
  "language_correct": "اللغة صحيحة",
  "cefr_fit": "المستوى مناسب",
  "objective_clear": "الهدف واضح",
  "meaningful_language_use": "يتطلب استخدامًا حقيقيًا للغة",
  "learner_instructions": "تعليمات المتعلّم واضحة",
  "teacher_instructions": "تعليمات المعلّم واضحة",
  "cultural_credibility": "موثوق ثقافيًا",
  "stereotype_risk": "بلا صور نمطية",
  "age_context": "مناسب للعمر والسياق",
  "copyright_provenance": "الحقوق / المصدر سليم",
  "privacy": "لا بيانات شخصية",
  "cards_accurate": "البطاقات دقيقة",
  "roles_balanced": "الأدوار متوازنة",
  "data_plausible": "البيانات معقولة",
  "answer_key_correct": "مفتاح الإجابات صحيح",
  "puzzle_solvable": "اللغز قابل للحل",
  "text_level": "النص بالمستوى المناسب",
  "authentic_format": "شكل أصيل",
  "realistic_form": "نموذج واقعي"
 }
};
export default al;
